import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/company_settings/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/settings/company_settings';

const Home: NextPage = () => (
  <>
    <NskHead title="会社設定" />
    <Component />
  </>
);

export default Home;
